import React, { Component } from 'react';
import { injectIntl } from 'react-intl';

class FineStatusTag extends Component {
    getStatusLabelText = () => {
        const { intl, fine } = this.props;

        // 2024-07-17: Brazil solicito solamente se muestre el ultimo status (Barbara)
        let texts = []; 
        let colorClass = 'purple';

        if ((fine?.fineStageID || 0) === 0) { //Eliminadas
            texts = [intl.formatMessage({ id: 'fines.status.deleted', defaultMessage: 'Deleted' })];
            colorClass = 'red';
        }

        else {
            if (!fine?.dateNotificationSent) //Fecha de notificacion faltante
                texts = [intl.formatMessage({ id: 'fines.status.notifyPending', defaultMessage: 'Notification pending' })];

            else if (!fine?.driverID) //No tienen conductor
                texts = [intl.formatMessage({ id: 'fines.status.identifyPending', defaultMessage: 'Identify pending' })];

            else if (!fine?.dateDriverInformed) //No se ha informado al conductor
                texts = [intl.formatMessage({ id: 'fines.status.assigmentPending', defaultMessage: 'Inform driver pending' })];

            else if (!fine?.dateDriverIndicationSend && fine?.fineStageID !== 100) //No se ha enviado indicacion y no tienen abono
                texts = [intl.formatMessage({ id: 'fines.status.indicationPending', defaultMessage: 'Indicate driver pending' })];
            
            else if (!fine?.transactionPurchaseID)
                texts = [intl.formatMessage({ id: 'fines.status.paymentPending', defaultMessage: 'Payment pending' })];

            // Brazil indica que si se recibio el cobro, se considera para pago
            if (!fine?.transactionPurchaseID && !!fine?.dateDriverIndicationArrive) {
                texts = [intl.formatMessage({ id: 'fines.status.paymentPending', defaultMessage: 'Payment pending' })];
            }

            //Tiene recurso pero no se ha aplicado
            if (fine?.fineStageID === 110) {
                texts = [intl.formatMessage({ id: 'fines.status.pendingRefund', defaultMessage: 'Refund pending' })];
                colorClass = 'yellow';
            }

            //Tiene apelacion
            if (fine?.fineStageID === 120) //Se encuentra en apelacion, falta que sea aceptada
                texts = [intl.formatMessage({ id: 'fines.status.underAppeal', defaultMessage: 'Under appeal' })];
            else if (fine?.fineStageID === 121) //Apelacion aceptada, falta que sea restituida
                texts = [intl.formatMessage({ id: 'fines.status.approvedAppeal', defaultMessage: 'Approved appeal' })];

            //Tiene abono
            if (fine?.fineStageID === 100) {
                texts = [intl.formatMessage({ id: 'fines.didInstallment', defaultMessage: 'Has installment' })];
            }

            if (!!fine?.transactionPurchaseID) { //Pagado, Brazil indico pagado se concidera concluido en refining
                texts = [intl.formatMessage({ id: 'fines.status.concluded', defaultMessage: 'Concluded' })];
                colorClass = 'green';
            }
        }
        
        return { texts, colorClass };
    }

    render() {        
        const { texts, colorClass } = this.getStatusLabelText();

        return <span className={`fine-tag ${colorClass}`}>
            {texts.join(', ')}
        </span>
    }
}
export default injectIntl(FineStatusTag);
